import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CryptoService } from '../services/crypto.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private cryptoService: CryptoService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let token = localStorage.getItem('token');
    
    // Si no hay token guardado con clave 'token', comprobar si 'sessionID' contiene un JWT válido
    if (!token || token === 'null' || token === 'undefined' || !token.startsWith('eyJ')) {
      const sessionID = localStorage.getItem('sessionID');
      if (sessionID && sessionID.startsWith('eyJ')) {
        token = sessionID;
      } else {
        token = null;
      }
    }

    let headers = req.headers;
    
    // Adjuntar Bearer token solo si existe un JWT válido
    if (token && !headers.has('Authorization')) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }

    // Solicitar respuesta cifrada al backend en todos los endpoints de la API
    headers = headers.set('x-encrypt-response', 'true');

    let clonedBody = req.body;
    // Cifrar el cuerpo de las peticiones POST/PUT/PATCH si contienen un objeto JSON (no FormData)
    if (req.body && typeof req.body === 'object' && !(req.body instanceof FormData) && !req.body.payload) {
      clonedBody = {
        payload: this.cryptoService.encryptPayload(req.body)
      };
    }

    const privatePaths = ['/user/', '/orders/', '/dashboard/', '/product', '/inmueble', '/partners'];
    const isPrivate = privatePaths.some(path => req.url.includes(path));
       
    const cloned = req.clone({
      headers,
      body: clonedBody,
      withCredentials: isPrivate
    });

    return next.handle(cloned).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse && event.body) {
          // Desencriptar respuesta encriptada enviada por el servidor { encrypted: true, payload: "..." }
          if ((event.body.encrypted || event.body.payload) && typeof event.body.payload === 'string') {
            const decrypted = this.cryptoService.decryptPayload(event.body.payload);
            if (decrypted !== null && decrypted !== undefined) {
              return event.clone({ body: decrypted });
            }
          }
        }
        return event;
      })
    );
  }
}
